module.exports = __webpack_public_path__ + "static/media/ic_hs_insured.eba34f14.svg";